const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const createRetroBoard = async () => {
  const response = await fetch(`${API_URL}/api/retro-boards`, { method: 'POST' })
  if (!response.ok) throw new Error('Não foi possível criar o quadro.')
  return response.json()
}

export const fetchRetroState = async (id) => {
  const response = await fetch(`${API_URL}/api/retro-boards/${id}/state`)
  if (!response.ok) throw new Error('Quadro não encontrado.')
  return response.json()
}

export const addRetroCard = async (id, column, text) => {
  const response = await fetch(`${API_URL}/api/retro-boards/${id}/cards`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ column, text }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível enviar o cartão.')
  return data
}

// Pass whichever credential applies: masterToken lets the master remove any
// card (moderation), authorToken only works for the specific card it was
// issued for (self-deletion, no login involved).
export const removeRetroCard = async (id, cardId, { masterToken, authorToken } = {}) => {
  const headers = {}
  if (masterToken) headers['x-master-token'] = masterToken
  if (authorToken) headers['x-author-token'] = authorToken

  const response = await fetch(`${API_URL}/api/retro-boards/${id}/cards/${cardId}`, {
    method: 'DELETE',
    headers,
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível excluir o cartão.')
  return data
}

// visitorId scopes the reaction to this one browser tab (see
// retroVisitor.js) so the server can tell different reactors apart instead
// of trusting a shared counter.
export const setRetroCardReaction = async (id, cardId, visitorId, reacted) => {
  const response = await fetch(`${API_URL}/api/retro-boards/${id}/cards/${cardId}/react`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ visitorId, reacted }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível reagir.')
  return data
}

export const addRetroComment = async (id, cardId, text) => {
  const response = await fetch(`${API_URL}/api/retro-boards/${id}/cards/${cardId}/comments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível comentar.')
  return data
}

// Pass whichever credential applies: masterToken lets the master remove any
// comment (moderation), authorToken only works for the specific comment it
// was issued for (self-deletion, no login involved).
export const removeRetroComment = async (id, cardId, commentId, { masterToken, authorToken } = {}) => {
  const headers = {}
  if (masterToken) headers['x-master-token'] = masterToken
  if (authorToken) headers['x-author-token'] = authorToken

  const response = await fetch(`${API_URL}/api/retro-boards/${id}/cards/${cardId}/comments/${commentId}`, {
    method: 'DELETE',
    headers,
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível excluir o comentário.')
  return data
}

export const setRetroCardPinned = async (id, cardId, masterToken, pinned) => {
  const response = await fetch(`${API_URL}/api/retro-boards/${id}/cards/${cardId}/pin`, {
    method: 'POST',
    headers: { 'x-master-token': masterToken, 'Content-Type': 'application/json' },
    body: JSON.stringify({ pinned }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível fixar o cartão.')
  return data
}

export const retroStreamUrl = (id) => `${API_URL}/api/retro-boards/${id}/stream`

export const retroJoinUrl = (id) => `${window.location.origin}/ferramentas/retro-ao-vivo/${id}`
